import { darkTheme } from "@yleisradio/yds-core";
import styled from "styled-components";

import { focusColor } from "../../styles/variables";

export const CenterFloatingWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  position: absolute;
  width: 100%;
`;

export const CenterFloatingButton = styled.button<{
  isMobile: boolean;
  hasText?: boolean;
}>`
  align-items: center;
  background-color: rgb(0 0 0 / 49%);
  background-repeat: no-repeat;
  border-radius: 44px;
  border: none;
  color: ${darkTheme.ACTION_PRIMARY};
  cursor: pointer;
  display: flex;
  height: ${({ isMobile }) => (isMobile ? "58px" : "88px")};
  font-size: ${({ isMobile }) => (isMobile ? "1.5em" : "1.8em")};
  font-weight: lighter;
  justify-content: center;
  max-width: 100%;
  padding: ${({ hasText }) => (hasText ? "24px" : "0")};
  text-transform: uppercase;
  width: ${({ hasText, isMobile }) =>
    hasText ? "auto" : isMobile ? "58px" : "88px"};

  svg {
    height: ${({ isMobile }) => (isMobile ? "35px" : "50px")};
    margin-right: ${({ hasText }) => (hasText ? "8px" : "0")};
    width: ${({ isMobile }) => (isMobile ? "35px" : "50px")};
  }

  &:hover {
    background-color: rgb(0 0 0 / 55%);
  }

  &:focus-visible {
    outline: 1px solid ${focusColor} !important;
  }
`;
